import React, { useEffect, useMemo, useState } from "react";
import NavbarStandard from "../navbar/NavbarStandard";
import { Col, Row } from "reactstrap";
import CustomLogo from "../../assets/img/illustrations/new-sikka-logo.png";
import publicIp from "react-public-ip";
import Loader from "../common/Loader";
import { useLocation } from "react-router";
import AuthService from "../../services/authenticationService";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import DentalLLMImage from "../../assets/img/logos/DentalLLMPerCom.png";
const hostName = (url) => {
    if (url.includes("localhost")) {
        return "localhost";
    } else if (url.includes("qa")) {
        return "qa";
    } else {
        return "prod";
    }
};
const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
};
const SikkaDentalLlm = () => {
    const [loading, setLoading] = useState(false);
    const [ip, setIp] = useState(null);
    useMemo(() => {
        async function getIPAddress() {
            let tempIp = await publicIp.v4();
            if (tempIp) {
                setLoading(false);
                setIp(tempIp);
            }
        }
        getIPAddress();
    }, []);
    const query = useQuery();
    var from_where = "other";
    if (query.get("ref")) {
        from_where = query.get("ref")
    }
    useEffect(() => {
        if (ip) {
            const body = {
                from_where: from_where,
                ip_address: ip,
                host_name: hostName(window.location.href),
            };
            AuthService.dentalllmTrackingCall(body).then(
                () => { },
                (error) => {
                    const resMessage =
                        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();

                }
            );
        }
    }, [ip])
    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <div id="sikka-llm-page"
                    style={{ height: "80em" }}
                >
                    <NavbarStandard isMenuShow={false} customLogo={CustomLogo} />

                    <div className="heading">
                        <h1>
                            First ready to use Specialized Sikka.ai Dental LLM – uses 15+ years of data
                        </h1>
                        {/* <p>15 years of opt-in de-identified</p> */}
                    </div>

                    <p>
                        We are thrilled to announce the results of DentalLLM from Sikka.ai. This model outperforms Openai’s GPT-4, Google’s Gemini 1.5, and Anthropic's Claude 3 Sonnet and it relies on the data from 30K+ dental practices across the US on the  <span className="sikka-llm-link">
                            <a href={"https://sikka.ai/oneapi"} target="_">
                                sikka platform
                            </a>
                        </span>.  With access to dental practice data in real-time, this model will provide accurate information that is missing from various state-of-the-art models making it the very first Dental Language Model for the dental domain. This model was iterated on various agents, prompting strategies and data-storing techniques.

                    </p>
                    <div className="text-center">
                    <img  src={DentalLLMImage}
                    alt="DentalLLMImage"
                    id="dental-llm-image"
                    srcset={DentalLLMImage}
                    style={{
                      width: "50%",
                      verticalAlign:"middle"
                      // boxShadow:" 0px 0px 10px 1px black"
                    }}/>
                    <p>Answer accuracy for dental trend knowledge questions for DentalLLM compared to other vanilla LLMs.</p>
                    </div>
                    <p>
                        As part of the continuous improvement process at Sikka, we plan to improve our coverage of practice-level and industry-level information through our model. We will be releasing our official research paper soon.
                    </p>
                    <div className="text-center">
                        <Button
                            variant="falcon-primary"
                            style={{ paddingTop: "3px", paddingBottom: "3px" }}
                            size="sm"
                            onClick={() => {
                                window.location.assign(`${process.env.PUBLIC_URL}/authentication/register?ref=DentalLLM`);
                            }}
                        >
                            Join our waitlist
                        </Button>
                    </div>
                    {/* <br />
                    <p className="text-center">
                        Contact us at{""}
                        <span className="sikka-llm-link">
                            <a href={"https://sikka.ai/request-quote"} target="_">
                                Sikka ONE API
                            </a>
                        </span>{" "}
                    </p> */}
                </div>
            )}
        </>
    );
};

export default SikkaDentalLlm;
